module.exports = __webpack_public_path__ + "static/media/IMG_7051a.479c1886.jpg";